var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusIconCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Cancel  ",
    id: "Cancel_",
    transform: "translate(-17629 4804)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    id: "Back",
    transform: "translate(17629 -4804)",
    width: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "no-delivery_7026181",
    transform: "translate(17627.5 -4805.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.3,19.9a.8.8,0,1,1-.8.8A.8.8,0,0,1,6.3,19.9Z",
    "data-name": "Path 8351",
    fill: "#ffff",
    fillRule: "evenodd",
    id: "Path_8351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,19.9a.8.8,0,1,1-.8.8A.8.8,0,0,1,9.5,19.9Z",
    "data-name": "Path 8352",
    fill: "#ffff",
    fillRule: "evenodd",
    id: "Path_8352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.33,2.67A3.975,3.975,0,0,0,21.5,1.5H5.5a4,4,0,0,0-4,4v16a4,4,0,0,0,4,4h6.4V23.9H5.5a2.4,2.4,0,0,1-2.4-2.4V5.5A2.4,2.4,0,0,1,5.5,3.1h4v6.4a.8.8,0,0,0,1,.75l3-.75,3,.75a.833.833,0,0,0,.682-.143.8.8,0,0,0,.307-.63V3.1h4a2.4,2.4,0,0,1,2.4,2.4v6.4H25.5V5.5A3.967,3.967,0,0,0,24.33,2.67Zm-8.43,5.8-2.2-.555a.8.8,0,0,0-.39,0l-2.2.555V3.1h4.8Z",
    "data-name": "Path 8353",
    fill: "#ffff",
    id: "Path_8353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1,12.7a6.4,6.4,0,1,0,6.4,6.4,6.4,6.4,0,0,0-6.4-6.4Zm0,1.6a4.77,4.77,0,0,1,2.775.893L15.195,21.87A4.792,4.792,0,0,1,19.1,14.295Zm0,9.6A4.77,4.77,0,0,1,16.327,23L23.01,16.32A4.792,4.792,0,0,1,19.1,23.895Z",
    "data-name": "Path 8354",
    fill: "#ffff",
    id: "Path_8354"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIconCancel);
export default __webpack_public_path__ + "static/media/status_icon_cancel.2214ce309db9e1c0e4e17a31a1e4d2d6.svg";
export { ForwardRef as ReactComponent };